/* eslint-disable max-len */
import { FC } from 'react';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';

export const MenuExperiencesIcon: FC<CommonIconProps> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.50005 13.5164C7.06513 13.5164 6.71255 13.8821 6.71255 14.3331C6.71255 14.7841 7.06513 15.1498 7.50005 15.1498H16.5001C16.935 15.1498 17.2876 14.7841 17.2876 14.3331C17.2876 13.8821 16.935 13.5164 16.5001 13.5164H7.50005Z"
      fill="currentColor"
    />
    <path
      d="M6.71255 17.8331C6.71255 17.3821 7.06513 17.0164 7.50005 17.0164H14.2501C14.685 17.0164 15.0376 17.3821 15.0376 17.8331C15.0376 18.2841 14.685 18.6498 14.2501 18.6498H7.50005C7.06513 18.6498 6.71255 18.2841 6.71255 17.8331Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.375 6.16667C6.375 5.52233 6.87868 5 7.5 5H16.5C17.1213 5 17.625 5.52233 17.625 6.16667V10.8333C17.625 11.4777 17.1213 12 16.5 12H7.5C6.87868 12 6.375 11.4777 6.375 10.8333V6.16667ZM7.95 10.3667V6.63333H16.05V10.3667H7.95Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 3.83333C3 2.54467 4.00736 1.5 5.25 1.5H18.75C19.9926 1.5 21 2.54467 21 3.83333V20.1667C21 21.4553 19.9926 22.5 18.75 22.5H5.25C4.00736 22.5 3 21.4553 3 20.1667V3.83333ZM5.25 3.13333H18.75C19.1228 3.13333 19.425 3.44673 19.425 3.83333V20.1667C19.425 20.5533 19.1228 20.8667 18.75 20.8667H5.25C4.87721 20.8667 4.575 20.5533 4.575 20.1667V3.83333C4.575 3.44673 4.87721 3.13333 5.25 3.13333Z"
      fill="currentColor"
    />
  </svg>
);
